var render = function render(_c,_vm){return _c('section',{staticClass:"content",class:_vm.props.size ? `is-${_vm.props.size}` : null},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }